<script lang="ts">
	import { page } from '$app/state';
	import { Logo, Theme } from '$lib/components';
	import LogoutButton from '$lib/components/UI/Buttons/LogoutButton.svelte';
	import type { Auth } from '$lib/types';
	import { Menu } from 'lucide-svelte';

	type Props = {
		user: Auth | undefined;
		name: string;
		slogan: string;
	};

	let { user, name, slogan }: Props = $props();
	let showMenu = $state(false);

	function closeMenu() {
		showMenu = false;
	}

	$effect(() => {
		if (page.url.pathname) {
			closeMenu();
		}
	});
</script>

<nav class="print:hidden navbar">
	<div class="flex justify-between items-center ~px-5/8 py-3">
		<a
			href="/"
			title="Shuttle Shared Service and Private Taxi"
			class="flex items-center gap-x-3 group"
		>
			<Logo />
			<p class="~text-xl/3xl font-semibold uppercase">{name}</p>
			<p class="hidden lg:inline-block text-xl">{slogan}</p>
		</a>

		<ul class="hidden lg:flex gap-x-4 items-center">
			<li>
				<Theme />
			</li>
			{@render links()}
		</ul>
		<button class="block lg:hidden" aria-label="Menu" onclick={() => (showMenu = !showMenu)}>
			<Menu />
			<span class="sr-only">Menu</span>
		</button>
	</div>
	<div class:hidden={!showMenu} class="lg:block pt-0.5 pb-1">
		<ul class="flex gap-y-2 lg:hidden flex-col py-3 px-5">
			{@render links()}
			<li>
				<Theme />
			</li>
		</ul>
	</div>
</nav>

{#snippet links()}
	{#key {}}
		{#if user}
			<li>
				<a href="/user/profile">My account</a>
			</li>
			<li>
				<LogoutButton />
			</li>
		{:else}
			<li>
				<a href="/login" title="Sign in">Sign in</a>
			</li>
			<li>
				<a href="/create-account" title="Sign up">Sign up</a>
			</li>
		{/if}
	{/key}
{/snippet}
